import uid from './lib/uid';

export default uid;
